import { render, staticRenderFns } from "./CollectionProgress.vue?vue&type=template&id=1163b2b2&"
import script from "./CollectionProgress.vue?vue&type=script&lang=js&"
export * from "./CollectionProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports